import dayjs from 'dayjs';
import { getCategoryListMap } from "./courseCardHelper";
import { defaultBgImgId } from "../constants";

export function addDateObjectsToJournals(myJournals) {

    let dateValue;

    const today = dayjs();
    let dateObj = dayjs(myJournals?.[0]?.clientCreatedTime);

    if (today.isSame(dateObj, 'day')) {
        dateValue = "Today"
    } else {
        dateValue = dateObj.format('DD MMMM')
    }

    let newArray = [];
    newArray.push({ type: "dateItem", value: dateValue });

    if (Array.isArray(myJournals)) {
        myJournals?.forEach((item, index) => {

            let itemDate = dayjs(item?.clientCreatedTime);

            if (dateObj.isSame(itemDate, 'day')) {
                newArray.push(item)
            } else {
                newArray.push({ type: "dateItem", value: itemDate.format('DD MMMM') })
                newArray.push(item)
                dateObj = itemDate;
            }

        })
    }

    return newArray;
}

export function getDataFromRecommendation(recommendationData, setupData) {

    let categoryList = getCategoryListMap(setupData);
    let itemType;
    let title;
    let description;
    let imgId;
    let cardData;
    let itemTitle;
    let noData = Boolean((recommendationData?.episode && Object.keys(recommendationData?.episode)?.length !== 0)
        &&
        (recommendationData?.breathe && Object.keys(recommendationData?.breathe)?.length !== 0)
        &&
        (recommendationData?.practice && Object.keys(recommendationData?.practice)?.length !== 0))

    title = recommendationData?.title;
    description = recommendationData?.description;

    if (recommendationData?.episode && Object.keys(recommendationData?.episode)?.length !== 0) {
        itemType = "course";
        imgId = recommendationData?.episode?.coverImage || recommendationData?.episode?.coverIcon;
        itemTitle = recommendationData?.episode?.title;
        cardData = {
            "course": {
                "id": recommendationData?.episode?.courseId || "",
                "title": recommendationData?.episode?.title || "",
                "longDesc": recommendationData?.episode?.longDesc || "",
                "courseType": recommendationData?.episode?.sessionType || "",
                "categoryId": [
                    recommendationData?.episode?.category[0] || "",
                ],
                "courseCategory": categoryList ? (categoryList?.get(recommendationData?.episode?.category[0]?.singleTitle || categoryList?.get(recommendationData?.episode?.category[0]?.name))) : '',
                "sessions": [
                    {
                        ...recommendationData?.episode
                    }
                ]
            }
        }
    } else if (recommendationData?.breathe && Object.keys(recommendationData?.breathe)?.length !== 0) {
        itemType = "breathe";
        imgId = recommendationData?.episode?.coverImage || recommendationData?.episode?.coverIcon || "";
        itemTitle = recommendationData?.breathe?.name || "";
    } else if (recommendationData?.practice && Object.keys(recommendationData?.practice)?.length !== 0) {
        itemType = "practice";
        imgId = recommendationData?.practice?.coverImage || recommendationData?.practice?.coverIcon || "";
        itemTitle = recommendationData?.practice?.title || "";
    }

    return { itemType, title, description, imgId, itemTitle, cardData, noData };

}

export function getJournalCardDetails(card, categoryListMap) {

    const journalTitle = card?.journal?.title || '';
    const journalCategory = categoryListMap ? (categoryListMap?.get("myJournal")?.singleTitle || categoryListMap?.get("myJournal")?.name) : '';
    const journalIconImage = card?.journal?.coverIcon;
    const journalCoverImage = card?.journal?.coverImage;
    const journalVerticalImage = card?.journal?.verticalImage || card?.journal?.coverImage || card?.journal?.coverIcon || defaultBgImgId;

    return { journalTitle, journalCategory, journalIconImage, journalCoverImage, journalVerticalImage }
}